<mwe-form [formModel]="countryFormModel" />

@if (!useManualAddressForm) {
  <mwe-address-input
    [ignoreAvailableZipCodes]="true"
    [selectedAddress]="initialOlavEntry"
    noResultsButtonText="shared.international-address-input.noResultsButtonText"
    (allSearchParametersEntered)="receiveSelectionFinished($event)"
    (noResultsButtonClicked)="changeToManualAddressForm()"
  />
}
@if (useManualAddressForm) {
  <mwe-manual-address-input [initialData]="initialDataForManualForm" (formChanged)="receiveSelectionFinished($event)" />
}
